/* eslint-disable @next/next/no-img-element */
import React from 'react';

import { Point } from './header/header.types';

import { withCssModulesClassNames } from '../../common/nextMigrationHelpers';
// eslint-disable-next-line import/no-named-default
import { default as styles } from '../../scss/components/ProductAttributeSet.module.scss';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

interface ProductAttributeSetPointsProps {
  type: 'collapsed-points' | 'expanded-points';
  point: Point;
  selectedIcon: number | null;
  handleOpen: (index: number) => void;
  index?: number;
}

function ProductAttributeSetPoints({
  type, point, handleOpen, index,
}: ProductAttributeSetPointsProps) {
  const handleClick = () => {
    if (type === 'collapsed-points' && index !== undefined) {
      handleOpen(index);
    }
  };

  return (
    <div className={withCssModulesClassNamesHandler(type)} data-testid={type} onClick={handleClick}>
      <img
        className={withCssModulesClassNamesHandler('icon')}
        src={point.images[0].url}
        alt="test alt"
        style={{
          position: 'relative',
          top: 0,
          left: 0,
          transition: 'opacity 0.5s',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
      {type === 'expanded-points' && (
        <div className={withCssModulesClassNamesHandler('text-container')}>
          <h3 className={withCssModulesClassNamesHandler('expanded-header')}>{point.header}</h3>
          <p>{point.copy}</p>
        </div>
      )}
    </div>
  );
}

export default ProductAttributeSetPoints;
